import React from "react";
import { PROFILE } from "../../data/profile";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <span className="text-eyebrow">// 01 · About</span>
            <h2 className="text-display mt-4 text-[3rem] sm:text-[3.6rem] leading-[0.95]">
              The <em className="italic text-[var(--jewel)]">engineer</em>{" "}
              behind the code.
            </h2>
          </div>
          <div className="md:col-span-7 md:col-start-6">
            <p className="font-serif text-xl sm:text-2xl leading-relaxed text-foreground/85">
              I’m a results-driven Software Developer with{" "}
              <em className="italic text-[var(--jewel)]">4+ years</em> of professional experience
              designing, developing and deploying robust applications.
            </p>
            <p className="mt-6 text-base text-muted-foreground leading-relaxed max-w-2xl">
              My expertise lives at the intersection of <strong className="text-foreground">Python, Django, REST APIs, AWS Cloud</strong> and
              <strong className="text-foreground"> AI-driven solutions using OpenAI & Machine Learning</strong>.
              I enjoy solving complex problems, optimizing performance, and building scalable systems
              that survive production traffic and the test of real users.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-4">
              {[
                { k: "Focus", v: "Backend · AI · Cloud" },
                { k: "Stack", v: "Python · Django · AWS" },
                { k: "Based in", v: PROFILE.location },
                { k: "Status", v: "Open to roles" },
              ].map((it) => (
                <div
                  key={it.k}
                  className="rounded-xl border border-white/10 bg-white/[0.02] p-4"
                  data-testid={`about-fact-${it.k.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <div className="font-mono-ed text-[0.65rem] uppercase tracking-widest text-muted-foreground">
                    {it.k}
                  </div>
                  <div className="mt-1.5 text-sm text-foreground">{it.v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
